const getAncestorElements = (element, parameters) => {
    const ancestors = [];
    while (element) {
        if (parameters?.root && element == parameters?.root) {
            break;
        }

        const tagName = element.nodeName.toLowerCase();
        const id = element.id ? `#${element.id}` : '';
        let className = '';
        if (element.className && typeof element.className === 'string') {
            // escape class names
            className = `.${element.className
                .trim()
                .replace(/\s+/g, '.')
                .replace(/[:*+?^${}()|[\]\\]/gi, '\\$&')}`;
        }

        ancestors.unshift({
            element,
            selector: tagName + id + className
        });

        element = element.parentNode !== document ? element.parentNode : false;
    }

    return ancestors;
};

const getNthIndex = (element, sameType = true) => {
    let c = element;
    let nth = 1;
    while (c.previousElementSibling !== null) {
        if (
            !sameType ||
            c.previousElementSibling.nodeName === element.nodeName
        ) {
            nth++;
        }
        c = c.previousElementSibling;
    }

    return nth;
};

const isNthSelectorNeeded = (selector, path) => {
    const querySelector = path === '' ? selector : `${path} > ${selector}`;

    return document.querySelectorAll(querySelector).length > 1;
};

const buildSelectorString = (parents) => {
    const selectorArr = [];

    parents.forEach((parent) => {
        if (isNthSelectorNeeded(parent.selector, selectorArr.join(' > '))) {
            parent.selector += `:nth-of-type(${getNthIndex(parent.element)})`;
        }
        selectorArr.push(parent.selector);
    });

    return selectorArr.join(' > ');
};

const getElementSelector = (element, parameters) => {
    if (!(element instanceof HTMLElement)) {
        throw new Error('element must be of type `HTMLElement`.');
    }

    return buildSelectorString(getAncestorElements(element, parameters));
};

export {getElementSelector};
